// extracted by mini-css-extract-plugin
export default {"joinGroupContainer":"JoinGroup_joinGroupContainer__+I03L","header":"JoinGroup_header__S4+J+"};